import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IfLoggedInDirective } from '@df/session/customer/if-logged-in.directive';
import { IfNotLoggedInDirective } from '@df/session/customer/if-not-logged-in.directive';
import { WishlistQtyComponentDef } from '@df/session/wishlist/wishlist-qty.component.def';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { LOGIN_FORM_MODAL_ID } from '../../../../login/form/modal/login-form-modal.component';
@Component({
    selector: 'wishlist-qty',
    templateUrl: './wishlist-qty.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [RouterLink, RouterLinkActive, IfLoggedInDirective, IfNotLoggedInDirective, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WishlistQtyComponent extends WishlistQtyComponentDef {
    protected readonly LOGIN_FORM_MODAL_ID = LOGIN_FORM_MODAL_ID;
}
